module.exports = __webpack_public_path__ + "static/media/MBBranding2@2x.10fcdf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MBBranding2@2x.png
// module id = 211
// module chunks = 0